import React from 'react';
import { components, OptionProps } from 'react-select';

function SelectOption(props: OptionProps) {
  const { innerProps, isSelected } = props;
  // To make options selectable with VoiceOver/TalkBack, We should avoid using tabindex="-1".
  const { tabIndex: _tabIndex, ...allOtherParams } = innerProps;

  return (
    <components.Option
      {...props}
      innerProps={{
        ...allOtherParams,
        'aria-selected': isSelected,
        role: 'option'
      }}
    />
  );
}

export default SelectOption;
